<template>
  <table class="first">
    <tbody>
      <tr>
        <td :colspan="titleColspan" class="black label">
          {{ heroTitle }}
        </td>
      </tr>
      <tr>
        <td class="black label">Poz.</td>
        <td class="black label">Nr</td>
        <td class="black label name">
          {{ pilot ? "Kierowca" : "Zawodnik" }}
        </td>
        <td v-if="pilot" class="black label name">Pilot</td>
        <td
          v-for="stage in liveStages"
          :key="stage.stageId"
          class="black label"
          style="min-width: 3rem; text-align: center"
        >
          {{ stage | makeStageNameShorter(pilot) }}
        </td>
        <td class="black label" style="min-width: 3rem">Suma</td>
      </tr>
      <tr v-for="result in liveResults.slice(dynamicRows * page, dynamicRows * (page + 1))" :key="result.number">
        <td class="black">{{ result.pos }}</td>
        <td class="black number">{{ result.number }}</td>
        <td class="black name">
          <country-flag :country="getFlag(result.driver.nationality)" size="small" class="flag" />
          {{ result.driver.surname }}
        </td>
        <td v-if="pilot" class="black name">
          <template v-if="result.pilot">
            <country-flag :country="getFlag(result.pilot.nationality)" size="small" class="flag" />
            {{ result.pilot.surname }}
          </template>
        </td>
        <td v-for="time in result.allTimes" :key="time.stageNo" class="black" style="text-align: center">
          {{ isNaN(time.result) ? time.result : (time.result + time.penalty) | formatResult(resultPrecision) }}
        </td>
        <td class="black" style="font-weight: bold">
          {{ isNaN(result.result) ? result.result : (result.result + result.penalty) | formatResult(resultPrecision) }}
        </td>
      </tr>
      <tr>
        <td :colspan="titleColspan" class="black" style="text-align: right">więcej na wyniki-online.pl</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import CountryFlag from "vue-country-flag"
import axios from "axios"
export default {
  name: "LiveTableMulti",
  data: () => ({
    page: 0,
    pageInterval: null,
    timePerPage: 5,
    dynamicRows: 10,
    liveConfig: {},
  }),
  props: {
    liveResults: Array,
    heroTitle: String,
    resultPrecision: Number,
    nowStage: Number,
    liveStages: Array,
    pilot: Boolean,
  },
  components: {
    CountryFlag,
  },
  computed: {
    titleColspan: function () {
      return 3 + (this.pilot ? 1 : 0) + this.liveStages.length + 1
    },
  },
  mounted() {
    axios.get("/liveConfig.json").then((response) => {
      const data = response.data
      this.liveConfig = data.liveConfig
      if (this.liveConfig.tableMulti.timePerPage) this.timePerPage = this.liveConfig.tableMulti.timePerPage
      if (this.liveConfig.tableMulti.dynamicRows) this.dynamicRows = this.liveConfig.tableMulti.dynamicRows
      this.startPageInterval()
    })
    this.startPageInterval()
  },
  methods: {
    getFlag: function (value) {
      if (value === "KOS") return "xk"
      return value
    },
    startPageInterval: function () {
      this.page = 0
      if (this.pageInterval) clearInterval(this.pageInterval)
      this.pageInterval = setInterval(() => {
        this.page++
        if (this.liveResults.length <= this.page * this.dynamicRows) this.page = 0
      }, this.timePerPage * 1000)
    },
  },
  filters: {
    formatResult: function (result, resultPrecision) {
      if (isNaN(result)) return result
      if (result === null || result === 0) return "-"

      const ms = result % 1000
      const sec = ((result - ms) / 1000) % 60
      const min = (((result - ms) / 1000 - sec) / 60) % 60
      const hrs = (((result - ms) / 1000 - sec) / 60 - min) / 60
      const format = (input) => String(input).padStart(2, "0")
      const formatMs = (ms) => String(ms).padStart(3, "0").slice(0, resultPrecision)
      if (hrs > 0) return `${hrs}:${format(min)}:${format(sec)},${formatMs(ms)}`

      return `${format(min)}:${format(sec)},${formatMs(ms)}`
    },
    makeStageNameShorter: function (stage, pilot) {
      if (pilot) {
        const minusIndex = stage.name.indexOf("-")
        if (minusIndex > 0) return stage.name.slice(0, minusIndex - 1)
      } else if (stage.name.includes("podjazd")) {
        let res = stage.name.replace(" podjazd", "")
        const spaceIndex = stage.name.indexOf(" ")
        if (spaceIndex > 0) return res.slice(0, spaceIndex + 5) + "."
      }

      return stage.name
    },
  },
}
</script>

<style lang="scss" scoped>
table {
  table-layout: auto !important;
  width: auto !important;
  margin-right: auto;
  margin-left: auto;

  &.first {
    width: auto;

    td {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      border-collapse: collapse;
      border: 5px solid #00ff00;
      font-size: 16px;
      text-align: left;
      &.number {
        text-align: center;
      }
      &.name {
        min-width: 12rem;
      }
      &.black {
        &:first-child,
        &:last-child,
        time {
          padding: 6px 8px 6px 8px;
          text-align: center;
        }
      }
    }

    tr.static-row td {
      font-weight: bold;
    }
  }

  .label {
    font-weight: bold;
    font-size: 17px;
    padding: 1px 1px 1px 1px;
  }

  .black {
    text-align: left;
    background-image: url("/img/live/black_box.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-color: #262626;
    color: #ffffff;
    padding: 6px;
  }

  .flag {
    flex-shrink: 0;
    margin: -14px -22px;
  }
}
</style>
